<div
  class="long-time-loader non-blocking"
  [hidden]="!creatingDocument"
  [ngClass]="{ 'second-notification-box': sendingReport }"
>
  <div class="status-text">
    <div class="spinner-border" role="status"></div>
    <div class="info-text">
      <b> {{ 'text.addingDocument' | transloco }}: {{ docName }} </b>
      {{ 'text.addingDocumentInProgress' | transloco }}
    </div>
  </div>
</div>

<div
  class="long-time-loader non-blocking"
  [hidden]="!documentVersion"
  [ngClass]="{ 'second-notification-box': sendingReport || creatingDocument }"
>
  <div class="status-text">
    <div class="spinner-border" role="status"></div>
    <div class="info-text">
      <b> {{ 'text.addingDocumentVersion' | transloco }} {{ versionUploadLabel }}: {{ versionUploadName }} </b>
      {{ 'text.addingDocumentVersionInProgress' | transloco }}
    </div>
  </div>
</div>
